/* 布局 */
//前台
import Layout from "@views/layout";

const adminuserpendingRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "adminuserpending",
            name: "ADMINUSERPENDING",
            meta: {
                title: "管理员提示小窗口",
                sort: 1,
            },
            component: () => import("@views/business/adminuserpending/index.vue"),
            redirect: {
                name: "ADMINUSERPENDING_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "ADMINUSERPENDING_LIST",
                    meta: {
                        title: "管理员提示小窗口",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/adminuserpending/list.vue"),
                },
                                                        ],
    },


        ],
};

export default adminuserpendingRouter;
